// @ts-strict-ignore
import { Action, createReducer, on } from '@ngrx/store';

import * as NewsActions from '../actions/news.actions';
import { NewsDetails } from '@fc-core/models/news-details.model';

export const newsFeatureKey = 'news';

export interface State {
  news: NewsDetails[];
  showNews: number;
}

export const initialState: State = {
  news: null,
  showNews: 0,
};

const newsReducer = createReducer(
  initialState,
  on(NewsActions.loadNewsSuccess, (state, action) => ({
    ...state,
    news: action.data,
  })),

  on(NewsActions.setShowNews, (state, action) => ({
    ...state,
    showNews: action.showNewsState,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return newsReducer(state, action);
}

export const getNews = (state: State) => state.news;
export const getShowNews = (state: State) => state.showNews;
